const NoDataAvailable = () => <p>No Data Available</p>

export default NoDataAvailable;